import { render } from "./AxxessHome.vue?vue&type=template&id=14234d45"
import script from "./AxxessHome.ts?vue&type=script&lang=js&external"
export * from "./AxxessHome.ts?vue&type=script&lang=js&external"

import "./AxxessHome.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__